module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Layout 404 */

(function(fox) {
	fox.registerWidget('Api_Pager', {

		configure: function(options) {
			this.params = {
				limit: null,
				offset: null
			}

			this.pagerParams = {
				cp: null,
				rpp: null,
				total: 0,
				next: 0,
				prev: 0
			};

			this._pagerData = {}

			this.registerOptions('', {
				autoRender: false,
				template: 'simple_page',
				container: '.pager-container',

				currentPage: 1,
				pagesCount: 5,
				navPrefix: false,
				api: null,

				handleDom: {
					setPage: {
						target: '.page',
						event: 'click',
						callback: function(el, alias, scope) {
							scope.changePage($(el).attr('data-page'))
						}
					}
				}
			});
			
			this.callParent('configure', arguments);
		},

		running: function () {
			this.api = this.wom1(this.getOption('api'));

			if (!this.api) {
				console.warn('api is not defined');

				return;
			}

			this.setPagerParams('cp', this.getOption('currentPage'));
			this.setPagerParams('rpp', this.api.getOption('limit'));

			this.params.limit = this.api.getOption('limit');
			this.params.offset = this.api.getOption('limit') * (this.getOption('currentPage') - 1);

			this.navPrefix = this.getOption('navPrefix');

			if (this.navPrefix) {
				this.handleEvent(fox.Navigator, 'modified_' + this.navPrefix, 'loadPage', {
					listenHistory: true,
					alwaysActive: true
				});
			};

			this.handleEvent(this.api, 'success', this._handleApiResponse);
			this.handleEvent(this.api, 'error', this._handleApiResponse);
		},

		setPagerParams: function (param, value) {
			if (fox.isObject(arguments[0])) {
				this.pagerParams = arguments[0];

				return this;
			};

			this.pagerParams[param] = value;

			return this;
		},

		getPagerParams: function (param) {
			if (!fox.isSet(arguments[0])) {
				return this.pagerParams;
			};

			return this.pagerParams[param];
		},

		changePage: function (page) {
			if (page == 'next') {
				page = this.getPagerParams('next');
			}

			if (page == 'prev') {
				page = this.getPagerParams('prev');
			}

			if (page === 0) {
				return;
			}

			if (this.navPrefix) {
				fox.Navigator.set(this.navPrefix, page, false);
			} else {
				this.loadPage(page);
			}
		},

		load: function() {
			if (!this.api) {
				return;
			};
			this.dispatchEvent('loadPage', this.params);
		},

		loadPage: function (page) {
			if (!page) {
				return;
			};

			this.params.offset = this.getPagerParams('rpp') * (page - 1);
			this.load();
		},

		_calculatePagerData: function () {
			var data = fox.clone(this.pagerParams), start, leftOffset, rightOffset, end;

			if (data.total < 2) {
				this.removeFromDom();
				this._indom = false;
				this._rendered = false;
				this._pagerData = data;
			} else {
				data.first = 1;
				var cnt = this.getOption('pagesCount'),
					leftOffset = Math.floor(cnt/2),
					rightOffset = leftOffset,
					start, end;

				if (cnt % 2) {
					leftOffset--;
				}

				//calculating pages block
				if (data.cp <= leftOffset) {
					start = 1;
					rightOffset = rightOffset + (leftOffset - data.cp);
				} else {
					start = data.cp - leftOffset;
				}

				if (data.total <= (data.cp + rightOffset)) {
					end = data.total;
				} else {
					end = data.cp + rightOffset;
					if(end > data.total) {
						end = data.total;
					}
				}

				//do you need to show spacers
				if (start > data.first && cnt < data.total ) {
					data.startSpacer = 1;
				} else {
					data.startSpacer = 0;
				}

				if (data.total > (data.cp + leftOffset) && cnt < data.total) {
					data.endSpacer = 1;
				} else {
					data.endSpacer = 0;
				}
				
				data.pages = [];
				
				for (var i = start, l = end; i <= l; i++) {
					data.pages.push({
						id: i,
						page: i,
						current: i == data.cp,
						first: i == data.first,
						last: i == data.total,
						firstInBlock: i == start,
						lastInBlock: i == end
					});
				};

				this._pagerData = data;
			}
		},

		_handleApiResponse: function (resp) {
			this.setPagerParams('total', (Math.ceil(resp.answer.response.meta.totalCount / this.params.limit)));
			this.setPagerParams('cp', (Math.ceil(this.params.offset / this.params.limit) + 1));
			this.setPagerParams('next', (this.pagerParams.cp >= this.pagerParams.total) ? null : this.pagerParams.cp + 1);
			this.setPagerParams('prev', (this.pagerParams.cp <= 1) ? null : this.pagerParams.cp - 1);

			this._calculatePagerData();
			if (this._pagerData.total > 1) {
				this.setTemplateOptions(this._pagerData).render();
			}
		}

	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/pager.js
// module id = 334
// module chunks = 2